import Services from '../services/Services';
import initialState from '../store/state';
export default {
    resetState(state,callback) {
        Object.keys(initialState).forEach((key,index) => {
            state[key] = initialState[key]
            if (index === Object.keys(initialState).length - 1) callback();
        });
    },
    /**
     * Set environment properties like API endpoints
     * @param {State} state
     * @param {string|false} env
     */
    setEnv(state,env = process.env.NODE_ENV) {
        switch (env) {
            case 'development':
                state.env = 'dev';
                break;
            case 'staging':
                state.env = 'test';
                break;
            case 'production':
                state.env = 'production';
                break;
            default:
                state.env = 'dev';
        }
    },

    /**
     * Tenant mutators
     */
    setTenant(state,tenant) {
        state.tenant = tenant;
    },
    setDomain(state,domain) {
        state.domain = domain;
    },
    /**
     * User mutators
     */
    setUser(state,user) {
        state.user = user;
    },

    /**
    * General
    */
    hideModals(state,status) {
        state.showAddCardToSequenceModal = false;
        state.showAddMediaToCardModal = false;
        state.showAddSequenceToPolicyModal = false;
        state.showCardHelpModal = false;
        state.showColdDeckModal = false;
        state.showCreateCardModal = false;
        state.showCreateLocalRecordModal = false;
        state.showCreateMarketModal = false;
        state.showCreateProductLocalRecordModal = false;
        state.showCreateProductGroupLocalRecordModal = false;
        state.showCreateProductModal = false;
        state.showCreateProductGroupModal = false;
        state.showCreateMediaLibraryModal = false;
        state.showCreateMediaLibraryLocalRecordModal = false;
        state.showDeprecateMediaModal = false;
        state.showLogoutModal = false;
        state.showUpateThumbModal = false;
        state.showUpdateThumbModal = false;
        state.showUploadMediaModal = false;
        state.showUploadProductImageModal = false;
        state.showCardIconModal = false;
        state.showCopyVolumeLinksModal = false;
        state.showCopyLocalRecordModal = false;
        state.showDeleteProductModal = false;
        state.showRestoreProductModal = false;
        state.showDeleteRecordModal = false;
    },

    /**
    * Charts
    */
    setCharts(state,charts) {
        state.charts = charts;
    },

    /**
     * Cards
    */
    setCards(state,cards) {
        state.cards = cards;
        state.cardsLoaded = true;
    },

    setCardTypes(state,types) {
        state.cardTypes = types;
    },

    setActiveCard(state,card) {
        state.activeCard = card;
    },

    setActiveLocale(state,locale) {
        state.activeLocale = locale;
    },

    setActiveLocalRecord(state,record) {
        state.activeLocalRecord = record;
    },

    // updateActiveCardLocalRecordSection(state, section, subsection, value){
    //     console.log(value);
    //     state.activeLocalRecord[section][subsection] = value;
    // },

    setActiveLocalRecordSaved(state,record) {
        state.activeLocalRecordSaved = record;
    },

    showCardIconModal(state,status) {
        state.showCardIconModal = status
    },

    showCopyLocalRecordModal(state,status) {
        state.showCopyLocalRecordModal = status
    },

    showCopyVolumeLinksModal(state,status) {
        state.showCopyVolumeLinksModal = status
    },

    setCardIconContext(state,status) {
        state.cardIconContext = status;
    },

    /**
    * Media
    */
    setMedia(state,media) {
        state.media = media;
        state.mediaLoaded = true;
    },

    setActiveMedia(state,media) {
        state.activeMedia = media;
    },

    setMediaLoadedStatus(state,status) {
        state.mediaLoaded = status;
    },

    showAddCardToSequenceModal(state,status) {
        state.showAddCardToSequenceModal = status;
    },

    showMediaUploadModal(state,status) {
        state.showUploadMediaModal = status;
    },

    showUpdateThumbModal(state,status) {
        state.showUpdateThumbModal = status;
    },

    showDeprecateMediaModal(state,status) {
        state.showDeprecateMediaModal = status;
    },

    showColdDeckModal(state,status) {
        state.showColdDeckModal = status;
    },

    showLogoutModal(state,status) {
        state.showLogoutModal = status;
    },

    showCardHelpModal(state,status) {
        state.showCardHelpModal = status;
    },

    setAllProducts(state,products) {
        state.products = products;
    },

    setActiveProducts(state,product) {
        state.activeProduct = product;
    },

    setAllProductGroups(state,productGroups) {
        state.allProductGroups = productGroups;
    },

    setAllMediaLibraries(state,libraries) {
        state.allMediaLibraries = libraries;
    },

    setActiveMediaLibrary(state,mediaLibrary) {
        state.activeMediaLibrary = mediaLibrary;
    },

    showAddMediaToCardModal(state,status) {
        state.showAddMediaToCardModal = status;
    },

    showCreateCardModal(state,status) {
        state.showCreateCardModal = status
    },

    showCreateLocalRecordModal(state,status) {
        state.showCreateLocalRecordModal = status
    },

    showCreateMediaLibraryModal(state,status) {
        state.showCreateMediaLibraryModal = status
    },

    showCreateMediaLibraryLocalRecordModal(state,status) {
        state.showCreateMediaLibraryLocalRecordModal = status
    },

    showCreateProductLocalRecordModal(state,status) {
        state.showCreateProductLocalRecordModal = status
    },

    showCreateProductGroupLocalRecordModal(state,status) {
        state.showCreateProductGroupLocalRecordModal = status
    },

    showCreateMarketModal(state,status) {
        state.showCreateMarketModal = status
    },

    showCreateProductModal(state,status) {
        state.showCreateProductModal = status
    },

    showCreateProductGroupModal(state,status) {
        state.showCreateProductGroupModal = status
    },

    showUploadProductImageModal(state,status) {
        state.showUploadProductImageModal = status
    },

    showDeleteProductModal(state,status) {
        state.showDeleteProductModal = status;
    },

    showDeleteRecordModal(state,status) {
        state.showDeleteRecordModal = status;
    },

    showRestoreProductModal(state,status) {
        state.showRestoreProductModal = status;
    },

    setMediaTabs(state,tabs) {
        state.mediaTabs = tabs;
    },
    setActiveMediaTab(state,tab) {
        state.activeMediaTab = tab;
    },

    /**
    * Policies
    */

    setPolicies(state,policies) {
        state.policies = policies;
    },

    setLastPolicyOption(state,lastPolicyOption) {
        state.lastPolicyOption = lastPolicyOption;
    },

    setActivePolicy(state,policy) {
        state.activePolicy = policy;
    },

    showAddSequenceToPolicyModal(state,status) {
        state.showAddSequenceToPolicyModal = status;
    },

    setInteractionTypes(state,types) {
        state.interactionTypes = types;
    },

    setSelectedSequence(state,sequence) {
        state.selectedSequence = sequence;
    },

    /**
    * Markets
    */
    setMarkets(state,markets) {
        state.markets = markets;
        state.marketsLoaded = true;
    },

    setActiveMarket(state,market) {
        state.activeMarket = market;
    },

    /**
    * Sequences
    */

    setSequences(state,sequences) {
        state.sequences = sequences;
    },

    setActiveSequence(state,sequence) {
        state.activeSequence = sequence;
    },

    setSequenceCards(state,cards) {
        state.sequenceCards = cards;
    },

    setOriginalSequenceCards(state,cards) {
        state.originalSequenceCards = cards;
    },

    setSequenceStatus(state,status) {
        state.unsavedSequence = status;
    },

    /**
    * Products
    */

    setProducts(state,products) {
        state.products = products;
    },

    setActiveProduct(state,product) {
        state.activeProduct = product;
    },

    setIsPrimaryImage(state,status) {
        state.isEditingPrimaryImage = status;
    },

    setActiveProductGroup(state,productGroup) {
        state.activeProductGroup = productGroup;
    },

    /**
    * Errors
    */
    pushError(state,error) {
        if (error) {
            state.errors.push(error);
        }
    },
    clearErrors(state) {
        state.errors = [];
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js